// extracted by mini-css-extract-plugin
export default {"recos":"b1-z","productCardOverride":"c1-z","rowHasBadge":"d1-z"};